export function deepEqual(a: unknown, b: unknown): boolean {
  if (a === b) {
    return true;
  }

  if ((a === null) !== (b === null)) {
    return false;
  }

  if (a === null || b === null) {
    return false;
  }

  if (typeof a !== "object" || typeof b !== "object") {
    return false;
  }

  const akeys = Object.keys(<object>a);
  const bkeys = Object.keys(<object>b);
  if (akeys.length !== bkeys.length) {
    return false;
  }

  for (const ak of akeys) {
    if (!bkeys.includes(ak)) {
      return false;
    }
    if (!deepEqual((<any>a)[ak], (<any>b)[ak])) {
      return false;
    }
  }

  return true;
}
